#import "../fragments/AutomationEditorFields.graphql"

mutation UpdateAutomation($id: ID!, $input: AutomationInput!) {
  updateAutomation(id: $id, input: $input) {
    automation {
      ...AutomationEditorFields
    }
    issues {
      nodeId
      code
      exitRuleId
    }
  }
}
